module.exports = __webpack_public_path__ + "media/images/flags/bf-4275eb85c53fe2d0f6a824dd028d8455.svg";